import React, { useContext } from "react";
import { useParams, Link } from "react-router-dom";
import { AuthContext } from "../../helpers/AuthContext";
// Icons
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import PersonIcon from '@mui/icons-material/Person';
import { canUseEzeeAI, isEzeeAdministrator } from "../../utils/ezeeAccess";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

function ProfileLeftSidebar() {
  let { id } = useParams();
  const { authState } = useContext(AuthContext);
  return (
      <div className="leftSide my-instances-sidebar">
          <div className="ec-instance-core-nav">
          <div className="list-item">
            <a>
              <span className="list-item-icon"><EmojiPeopleIcon/></span><span className="list-item-text">Hi {authState.first_name}</span>
            </a>
          </div>
          <div className="list-item">
            <Link to={"/profile/" + id}>
              <span className="list-item-icon"><PersonIcon/></span><span className="list-item-text">My profile </span>
            </Link>
          </div>
          {canUseEzeeAI(authState) && (Number(authState.id) === Number(id) || isEzeeAdministrator(authState)) ? (
            <div className="list-item">
              <Link to={"/profile/" + id + "/ezee-ai"}>
                <span className="list-item-icon"><AutoAwesomeIcon/></span><span className="list-item-text">Ezee AI</span>
              </Link>
            </div>
          ) : null}
          <div className="list-heading">MANAGE</div>
          <div className="list-item">
            <Link to={"/profile/" + id + "/change-password"}>
              <span className="list-item-icon"><VpnKeyIcon></VpnKeyIcon></span><span className="list-item-text">Change password</span>
            </Link>
          </div>
          { authState.role == "administartor" ?
          <div className="list-item">
            <Link to={"/profile/" + id + "/payment-methods"}>
              <span className="list-item-icon"><CreditCardIcon/></span><span className="list-item-text">Payment methods</span>
            </Link>
          </div>
          : "" }
        </div>
      </div>
  );
}

export default ProfileLeftSidebar;
